import styled from "styled-components";
import { breakpoints } from "styles";
import { Container } from "styles/common/container";
import Image from "next/legacy/image";

export const Wrapper = styled.section`
  background-color: ${({ theme }) => theme.colors.yellow[50]};
`;

export const ExploreTeachersContainer = styled(Container)`
  display: flex;
  overflow: hidden;
  padding: 64px 100px;
  @media ${breakpoints.mobile} {
    padding: 40px 20px;
    flex-direction: column;
    gap: 24px;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 1100px;
  gap: 24px;
  align-items: left;
  justify-content: center;
  @media ${breakpoints.mobile} {
    width: 400px;
    align-items: center;
  }
`;

export const MoneyBackGuaranteeContainer = styled(Container)`
  display: flex;
  flex-direction: row;
  @media ${breakpoints.mobile} {
    padding: 0;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
    gap: 24px;
  }
`;

export const ImageWrapper = styled.figure`
  position: relative;
  width: 100%;
  height: 100%;
  margin: 0;
  @media ${breakpoints.tablet} {
    max-width: 460px;
  }
`;

export const Heading = styled.h2`
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: 24px;
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  width: fit-content;
  margin: 0 0 16px;
  text-align: center;
  text-wrap: balance;
  @media ${breakpoints.tablet} {
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    line-height: 42px;
    text-align: left;
  }
  @media ${breakpoints.mobile} {
    font-size: ${({ theme }) => theme.fontSizes.sxl};
    line-height: 28px;
    margin: 0;
    width: 300px;
    text-wrap: pretty;
  }
`;

export const Description = styled.p`
  margin: 0;
  font-family: ${({ theme }) => theme.fonts.secondary};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  text-align: center;
  @media ${breakpoints.tablet} {
    text-align: left;
    font-size: ${({ theme }) => theme.fontSizes["xl"]};
  }
`;

export const ExploreCTA = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  gap: 8px;
  width: fit-content;
  cursor: pointer;
  font-weight: bold;
  padding: 12px 24px;
  text-decoration: none;
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.blue[100]};
  color: ${({ theme }) => theme.colors.brand[500]};

  &:hover {
    background-color: ${({ theme }) => theme.colors.brand[200]};
  }
`;
export const ImageContainer = styled(Image)`
  width: 100vw;
  border-radius: 8px;

  @media ${breakpoints.mobile} {
    width: 50vw;
  }
`;
